import ComputePipeline from "../../lib/services/compute/computepipeline";
import { YuvFormat } from "../../lib/services/compute/yuvdefs";

export default class DirAngleAndColorsPipeline extends ComputePipeline {
  private device: GPUDevice;
  private layout: GPUBindGroupLayout;
  private format: YuvFormat;
  private blob2_buffer: GPUBuffer | null = null;

  constructor(key: string, shader: GPUShaderModule, device: GPUDevice,threads: number, format: YuvFormat) {
    super(key,threads);
    this.device = device;
    this.format = format;

    const V = GPUShaderStage.COMPUTE;
    const tex = { sampleType: "unfilterable-float" as const, viewDimension: "2d" as const, multisampled: false };

    const entries: GPUBindGroupLayoutEntry[] = format === "NV12"
      ? [
          { binding: 0, visibility: V, buffer: { type: "storage" } },
          { binding: 1, visibility: V, texture: tex },
          { binding: 2, visibility: V, texture: tex },
       
        ]
      : [
          { binding: 0, visibility: V, buffer: { type: "storage" } },
          { binding: 1, visibility: V, texture: tex },
          { binding: 2, visibility: V, texture: tex },
          { binding: 3, visibility: V, texture: tex },
         
        ];

    this.layout = device.createBindGroupLayout({ entries });
    this.pipeline = device.createComputePipeline({
      layout: device.createPipelineLayout({ bindGroupLayouts: [this.layout] }),
      compute: { module: shader, entryPoint: key },
    });
  }

  build(blob2_buffer: GPUBuffer): void {
    this.blob2_buffer = blob2_buffer;
  }

  rebuild(y_view: GPUTextureView, cbcr_or_cb_view: GPUTextureView, cr_view?: GPUTextureView): void {
    const entries: GPUBindGroupEntry[] = [
      { binding: 0, resource: { buffer: this.blob2_buffer! } },
      { binding: 1, resource: y_view },
      { binding: 2, resource: cbcr_or_cb_view },
      
    ];

    if (this.format === "I420" && cr_view) {
      entries.push({ binding: 3, resource: cr_view });
    }
  

    this.bindgroup = this.device.createBindGroup({ layout: this.layout, entries });
  }
}